import React from 'react';
import Loader from '../loader';
import SSMHomePage from '../../views/ssm-homepage/ssm-homepage';
import MarketComparison from '../../views/market-comparison/market-comparison';
import FFWDHomePage from '../../views/ffwd-homepage/ffwd-homepage';
import NGMHomePage from '../../views/ngm-homepage/ngm-homepage';
import AMSHomePage from '../../views/ams-homepage/ams-homepage';
import AMCHomePage from '../../views/amc-homepage/amc-homepage';
import AMPHomePage from '../../views/amp-homepage/amp-homepage';
import SCTHomePage from '../../views/sct-homepage/sct-homepage';
import { getCurrentProduct } from '../../app-actions';

const AuthenticatedRoot = () => {
  const productType = getCurrentProduct();
  if (productType === 'SSM') {
    return <SSMHomePage />;
  } else if (productType === 'MBS') {
    return <MarketComparison />;
  } else if (productType === 'FFWD') {
    return <FFWDHomePage />;
  } else if (productType === 'NGM') {
    return <NGMHomePage />;
  } else if (productType === 'AMS') {
    return <AMSHomePage />;
  } else if (productType === 'AMC') {
    return <AMCHomePage />;
  } else if (productType === 'AMP') {
    return <AMPHomePage />;
  } else if (productType === 'SCT') {
    return <SCTHomePage />;
  }
  return <Loader position="authenticated root" />;
};

export default AuthenticatedRoot;
